import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import useLocalStorage from './useLocalStorage';

const usePreserveScroll = () => {
	const router = useRouter();
	const url = router.pathname;
	const [scrollY, setScrollY] = useLocalStorage(`scrollY-${url}`, 0);
	const [isBack, setIsBack] = useLocalStorage('isBack', false);
	const [isPopulated, setIsPopulated] = useState(false);

	useEffect(() => {
		router.beforePopState(() => {
			setIsBack(true);
			return true;
		});
		const onRouteChangeStart = () => {
			setScrollY(window.scrollY);
			setIsBack(false);
		};

		router.events.on('routeChangeStart', onRouteChangeStart);
		return () => {
			router.events.off('routeChangeStart', onRouteChangeStart);
		};
	}, [router, setScrollY, setIsBack]);

	useEffect(() => {
		if (isPopulated && isBack) {
			window.scroll({
				top: scrollY ?? 0,
				behavior: 'auto',
			});
			setIsBack(false);
			setIsPopulated(false);
			setScrollY(0);
		}
	}, [isBack, isPopulated, scrollY]);

	return setIsPopulated;
};

export default usePreserveScroll;
